export function isNodeEvnProduction() {
  return process.env.NODE_ENV === 'production';
}
